import { EMOJI_GROUPS } from '../lib/emojis';

export function EmojiPicker({ value, onChange, label }: { value: string; onChange(emoji: string): void; label: string }) {
  return (
    <div className="emoji-picker" role="radiogroup" aria-label={label}>
      {EMOJI_GROUPS.map((group) => (
        <fieldset key={group.name} className="emoji-picker__group">
          <legend>{group.name}</legend>
          <div className="emoji-picker__grid">
            {group.emojis.map((emoji) => (
              <button
                key={`${group.name}-${emoji}`}
                type="button"
                role="radio"
                aria-checked={value === emoji}
                className="emoji-option"
                onClick={() => onChange(emoji)}
              >
                {emoji}
              </button>
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
